<template>
	<div v-if="applicationFormImg">
		{{applicationFormImg}}
		<div class="upload-data-strip f-cb" v-show="/\.(jpeg|jpe|jpg|gif|png|webp|bmp)$/i.test(applicationFormImg.entity.fileNewName)" @click="amplificationImg(applicationFormImg.entity.fileNewName)">
			<i class="el-icon-tickets"></i>
			<span>
							
                        	{{applicationFormImg!=''?applicationFormImg.entity.fileOldName:''}}
                        	</span>
			<span class="f-fr" style="cursor: pointer;">
                        	查看
                            </span>
		</div>

		<!--下载-->
		<div class="upload-data-strip f-cb" v-show="/\.(rar|iso|zip|cab)$/i.test(applicationFormImg.entity.fileNewName)" @click="download(applicationFormImg.entity.fileUrl+applicationFormImg.entity.fileNewName)">
			<i class="el-icon-tickets"></i>
			<span>{{applicationFormImg!=''?applicationFormImg.entity.fileOldName:''}}</span>
			<span class="f-fr" style="cursor: pointer;">下载 </span>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				//				applicationFormImg: this.materials
			}
		},
		props: ['applicationFormImg'],

		computed: { //			imgShow(){
			//				
			//			}
		},
		methods: {
			amplificationImg(url) {
				this.$alert('<img src=' + '/UploadImages/' + url + '></img>', {
					showConfirmButton: false,
					dangerouslyUseHTMLString: true,
					customClass: 'imgalert',
					callback: (done) => {}
				});
			},
			//			window.location="htpp://www.baidu.com/test.rar";
			download(url) {
				window.location = 'http://192.168.1.39:8025' + url;

			}
		}
	}
</script>

<style>

</style>